var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.0013 12.8337C10.223 12.8337 12.8346 10.222 12.8346 7.00033C12.8346 3.77866 10.223 1.16699 7.0013 1.16699C3.77964 1.16699 1.16797 3.77866 1.16797 7.00033C1.16797 10.222 3.77964 12.8337 7.0013 12.8337Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61927 6.99996L8.96094 5.65829C9.1301 5.48913 9.1301 5.20913 8.96094 5.03996C8.79177 4.87079 8.51177 4.87079 8.3426 5.03996L7.00094 6.38163L5.65927 5.03996C5.4901 4.87079 5.2101 4.87079 5.04094 5.03996C4.87177 5.20913 4.87177 5.48913 5.04094 5.65829L6.3826 6.99996L5.04094 8.34163C4.87177 8.51079 4.87177 8.79079 5.04094 8.95996C5.12844 9.04746 5.23927 9.08829 5.3501 9.08829C5.46094 9.08829 5.57177 9.04746 5.65927 8.95996L7.00094 7.61829L8.3426 8.95996C8.4301 9.04746 8.54094 9.08829 8.65177 9.08829C8.7626 9.08829 8.87344 9.04746 8.96094 8.95996C9.1301 8.79079 9.1301 8.51079 8.96094 8.34163L7.61927 6.99996Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.1555c7107012ca5e896064e359bdd61c.svg";
export { ForwardRef as ReactComponent };